// eslint-disable-next-line import/no-extraneous-dependencies
import flatpickr from 'flatpickr';

document.addEventListener('DOMContentLoaded', () => {
  const labels = document.querySelectorAll('.form-box__frame--checkbox label');

  labels.forEach((label) => {
    label.setAttribute('tabindex', 0);

    label.addEventListener('keydown', (e) => {
      if (e.key === 13 || e.key === 'Enter') {
        const checkbox = label.querySelector('input[type="checkbox"]');
        checkbox.checked = !checkbox.checked;
      }
    });
  });

  const dateInputs = document.querySelectorAll('.form-box__item--date input');
  let openCalendars = [];
  let checkOutDate = {};

  const config = {
    click: 'capture',
    altInput: false,
    altFormat: 'M d',
    dateFormat: 'Y-m-d',
    minDate: 'today',
    errorHandler: () => {},
    disableMobile: 'true',
    defaultDate: 'today',
    onOpen() {
      openCalendars.push(this);
    },
  };

  const checkInDate = flatpickr('#check-in-date', {
    ...config,
    defaultDate: '',
    onChange() {
      if (checkInDate.selectedDates[0].getTime() >= checkOutDate.selectedDates[0].getTime()) {
        checkOutDate.setDate(
          checkInDate.selectedDates[0].setDate(checkInDate.selectedDates[0].getDate() + 1),
        );
      }
    },
  });

  checkOutDate = flatpickr('#check-out-date', {
    ...config,
    defaultDate: '',
    minDate: new Date().fp_incr(1),
    onChange() {
      if (checkInDate.selectedDates[0].getTime() >= checkOutDate.selectedDates[0].getTime()) {
        checkInDate.setDate(
          checkOutDate.selectedDates[0].setDate(checkOutDate.selectedDates[0].getDate() - 1),
        );
      }
    },
  });

  dateInputs.forEach((input) => {
    input.setAttribute('readonly', true);
    const req = input.closest('.form-box__item--date').classList.contains('form-box__item--date-required');

    flatpickr(input, {
      ...config,
      defaultDate: req ? '' : 'today',
    });
  });

  document.addEventListener('scroll', () => {
    if (openCalendars.length > 0) {
      openCalendars.forEach((calendar) => {
        if (calendar.calendarContainer.classList.contains('open')) {
          calendar.close();
        }
      });

      openCalendars = [];
    }
  });
});
